window.fn_comp_map_init = function() {};

// Google Maps JavaScript API implementation kept for possible future reuse.
// The current contact map uses a simple iframe embed, so no API key is needed.
// Original implementation used Google Maps JS API, IntersectionObserver,
// [data-map] options and lib_nl_google_map marker initialization.
// (function($) {
// })(jQuery);
